import ModelState from './_util/model';

class CountriesState extends ModelState {
  get url() { return '/countries'; }
  get singular() { return 'country'; }
  get plural() { return 'countries'; }
}

export default CountriesState;



// WEBPACK FOOTER //
// ./spa/state/countries.jsx